export const VersionState = {
  published: 'published',
  draft: 'draft',
  publishedHistory: 'publishedHistory',
} as const;

export type VersionStates = (typeof VersionState)[keyof typeof VersionState];
